import React, {useEffect} from 'react'
import {Redirect, Switch, useLocation} from 'react-router-dom'
import {useAuth} from './components/Context/authcontext'
// import {clearSessionData} from '../../utils/sessionCleanup'
import secureLocalStorage from 'react-secure-storage'

export function Logout() {
  const {setAuthenticated} = useAuth()
  const {search} = useLocation()

  useEffect(() => {

     localStorage.clear()
    secureLocalStorage.clear();

    // clearSessionData()
    setAuthenticated(false)
  }, [setAuthenticated])

  return (
    <Switch>
      <Redirect to={{pathname: '/auth/login', search}} />
    </Switch>
  )
}
